import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 基础数据：查询既往病史列表
  static queryBaseSickness() {
    return request({
      url: `basic/pastHistory/list`,
      host: config.HOST_MALL
    });
  }

  // 查询会员既往病史
  static querySickness() {
    return request({
      url: `personal/getMedicalHistory`,
      host: config.HOST_MALL
    });
  }

  // 批量修改既往病史
  static alterSickness(params) {
    return request({
      url: `personal/batchSaveMedicalHistory`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Sickness/SicknessServ.js